import Apollo from "apollo-client";
import { createUploadLink } from "./apollo-upload";
import { InMemoryCache, IntrospectionFragmentMatcher } from "apollo-cache-inmemory";
import introspectionQueryResultData from "application/apollo/fragmentTypes.json";
import { ENV } from "application/constants/app-constants";
import { getInitialUrl } from "application/functions";

const getHost = () => {
  if (ENV === "local") {
    return "https://sscc-pre.central.inditex.grp/inetgeco/graphql";
  } else {
    return `${getInitialUrl()}/inetgeco${ENV === "preint" ? "-preint" : ""}/graphql`;
  }
};
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
});

const link = createUploadLink({
  uri: getHost(),
  credentials: "include",
});

const apolloClient = new Apollo({
  cache: new InMemoryCache({ fragmentMatcher }),
  link,
});

export default apolloClient;
